import React from 'react'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { css, CSSObject, SerializedStyles } from '@emotion/core'

type Props = {
  buttonType: ButtonType
  onClick: () => void
  isDisabled?: boolean
  width?: string | number
  height?: string | number
  shape?: 'round' | 'square'
  customCss?: CSSObject | SerializedStyles
}

export const FrontTabletButton: React.FC<Props> = ({ shape, children, customCss, ...props }) => {
  return (
    <Button
      width={160}
      height={60}
      fontSize={20}
      borderRadius={shape === 'square' ? 10 : 35}
      fontWeight={'normal'}
      customCss={css({ lineHeight: 1.5 }, customCss)}
      {...props}
    >
      {children}
    </Button>
  )
}
